import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '../../WithRouter';
import { ProfileContext } from '../../../context/Profile.context';
import { routes, verifiedSectionKeys } from '../../../constants';
import SectionNextActions from '../../SectionNextActions';
import { Notebook } from 'lucide-react';
import { Box, Card, CardContent, CardHeader, CardTitle } from '@otcmarketsgroup/otcm-ui-lib';
import CorporateAddresses from './CorporateAddresses';
import CompanyContactInformation from './CompanyContactInformation';

const ContactInformation = ({ params: { symbol } }) => {
  const [profileState] = useContext(ProfileContext);
  const showVerifyBox = !profileState.readOnly;

  return <Box display='flex' flexDirection='column' gap={2}>
    <Card>
      <CardHeader>
        <CardTitle icon={<Notebook />}>Contact Information</CardTitle>
      </CardHeader>
      <CardContent>
        <Box display='flex' flexDirection='column' gap={2}>
          <CorporateAddresses />
          <CompanyContactInformation />
        </Box>
      </CardContent>
    </Card>
    <SectionNextActions
      readOnly={!showVerifyBox}
      section={verifiedSectionKeys.CONTACT_INFO}
      linkTo={`${routes.PROFILE_PREFIX}/${symbol}/${routes.PEOPLE}/${routes.OFFICERS}`}
    />
  </Box>;
};

ContactInformation.propTypes = {
  params: PropTypes.shape({
    symbol: PropTypes.string
  })
};

export default withRouter(ContactInformation);
